import Overview from './overview.vue';
import MobFull from '@rebuild/materials/shared/customs_calendar/mobile/FullIndex.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/customs_calendar/context';

export function useSelfContext() {
	provideCurrentContext({
		inSlideM: true
	});
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	'mob-full': withProvider(MobFull, useSelfContext)
};
